import apiV2 from '../api/v2';
import { toApiError } from './apiErrors';
import type { AppointmentOriginEvent } from './adminAppointments';

export interface CreateAppointmentInput {
    date: string;
    time?: string;
    reason?: string;
}

export interface CreateAppointmentResult {
    id: string;
    patientId: string;
    practiceId: string;
    date: string;
    time: string | null;
    reason: string | null;
    noteId: string | null;
    canceledAt: string | null;
    exitedHold: boolean;
    mondaySynced: boolean;
    originEvent: AppointmentOriginEvent | null;
}

/**
 * Creates the patient's next appointment (date + optional time/reason).
 * Writes the Monday next-appointment-date column and exits "Hold - 2.
 * In-office step needed" when the case sits on it — see
 * createAppointmentService in backend/src/routes/api/v2/patients/appointment/.
 */
export async function createAppointment(
    patientId: string,
    input: CreateAppointmentInput
): Promise<CreateAppointmentResult> {
    try {
        const response = await apiV2.post<{ success: boolean; data: CreateAppointmentResult }>(
            `/patients/${encodeURIComponent(patientId)}/appointment`,
            input
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}
